import { useCallback, useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { AppConfig } from "../AppConfig";
import { Condition } from "../core/api/requests/store/search/types";
import { CampaignManager } from "../core/storage/CampaignManager";
import { LocalStorageManager } from "../core/storage/LocalStorageManager";
import { appActions } from "../ducks/app";
import { Campaign } from "../ducks/campaign/types";
import { Store, storeActions, storeSelectors } from "../ducks/store";
import { useAuth } from "./useAuth";

export const useStore = (conditions?: Condition[]) => {
  const dispatch = useDispatch();
  const { isLoggedIn } = useAuth();

  const [stores, setStores] = useState<Store[]>([]);

  const allStores = useSelector(storeSelectors.allStores);
  const favoriteStores = useSelector(storeSelectors.favoriteStores);
  const allPrefectures = useSelector(storeSelectors.allPrefectures);
  const selectablePrefectures = useSelector(
    storeSelectors.selectablePrefectures,
  );
  const campaign = LocalStorageManager.Instance.getObject<Campaign>(
    AppConfig.Instance.LocalStorageKey["campaign"],
  );

  const isStockItemMode = CampaignManager.isStockItemMode();
  const isEarlyBird = CampaignManager.isEarlyBirdMode();

  useEffect(() => {
    if (conditions) {
      dispatch(
        storeActions.getStores.started({
          conditions,
          onSuccess: setStores,
          campaign_id:
            (isStockItemMode || isEarlyBird) && campaign
              ? campaign.id
              : undefined,
        }),
      );
    }
  }, []);

  const setFavoriteStore = useCallback(
    (storeId: number, isFavorite: boolean, onSuccess?: () => void) => {
      if (!isLoggedIn) {
        return dispatch(
          appActions.showModal.started({
            title: "ログインしてください",
            nextButtonLabel: "閉じる",
            handleNext: () => dispatch(appActions.closeModal()),
          }),
        );
      }

      dispatch(
        storeActions.setFavoriteStore.started({
          store_id: storeId,
          enable: isFavorite,
          onSuccess: () => {
            const newStores = stores.map((store) => {
              if (store.id === storeId) {
                return { ...store, isFavorite };
              }
              return store;
            });
            setStores(newStores);
            onSuccess && onSuccess();
          },
        }),
      );
    },
    [stores, isLoggedIn],
  );

  return {
    allStores,
    stores,
    favoriteStores,
    allPrefectures,
    selectablePrefectures,
    setFavoriteStore,
  };
};
